import {Component, Input, OnInit} from '@angular/core';
import {InterfaceService} from '../../../services/interface.service';

@Component({
  selector: 'app-alert-error',
  templateUrl: './alert-error.component.html',
  styleUrls: ['./alert-error.component.scss']
})
export class AlertErrorComponent implements OnInit {
  @Input() error: any;
  public errorText: string | void = '';
  constructor(
    public interfaceService: InterfaceService,
    ) { }

  ngOnInit(): void {
    if (this.error) {
      this.errorText = this.interfaceService.errorHandling(this.error, false);
    }
  }

}
